// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3VAWo","header":"MessagesList_header__3ya0Q","chat":"MessagesList_chat__26iZX"};